// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Q0n8E","load8":"Loader_load8__YRixu"};